var map = {
	"./carousel1.jpg": 628,
	"./carousel2.jpg": 629,
	"./carousel3.jpg": 630,
	"./course/Bands1.jpg": 21,
	"./course/Bands2.jpg": 22,
	"./course/Drums1.jpg": 23,
	"./course/Drums2.jpg": 24,
	"./course/DrumsScore1-KELsMUSIC.jpg": 25,
	"./course/DrumsScore2-KELsMUSIC.jpg": 26,
	"./course/Guitar1.jpg": 27,
	"./course/JMC1.jpg": 28,
	"./course/JMC2.jpg": 29,
	"./course/Piano1.jpg": 30,
	"./course/Piano2.jpg": 31,
	"./course/PianoScore1-KELsMUSIC.jpg": 32,
	"./course/PianoScore2-KELsMUSIC.jpg": 33,
	"./course/PianoScore3-KELsMUSIC.jpg": 34,
	"./course/Violin1.jpg": 35,
	"./course/Violin2.jpg": 36,
	"./course/ViolinScore1-KELsMUSIC.jpg": 37,
	"./course/ViolinScore2-KELsMUSIC.jpg": 38,
	"./course/Vocals1.jpg": 39,
	"./course/pianoResult.jpg": 40,
	"./course/violinResult.jpg": 41,
	"./drums-course.jpg": 631,
	"./drums-head.jpg": 632,
	"./guitar-course.jpg": 633,
	"./guitar-head.jpg": 634,
	"./intro.jpg": 635,
	"./jmc-course.jpg": 636,
	"./jmc-head.jpg": 637,
	"./left.jpg": 638,
	"./piano-course.jpg": 639,
	"./piano-head.jpg": 640,
	"./right.jpg": 641,
	"./violin-course.jpg": 642,
	"./violin-head.jpg": 643,
	"./vocals-course.jpg": 644,
	"./vocals-head.jpg": 645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;